export default function () {

    function getRgbFilterString (rgb) {
        return rgb.match(/\d+/g)
    }
    function changeToRgba(arr) {
        return `rgba(${arr[0]},${arr[1]},${arr[2]},1)`
    }
    function changeToRgba255(arr) {
        return `rgba(${arr[0]},${arr[1]},${arr[2]},255)`
    }
    function changeToRgb(arr) {
        return `rgb(${arr[0]},${arr[1]},${arr[2]})`
    }
    function rgbToHsb(rgb){
        let [r,g,b] = [...rgb]
        r = r / 255
        g = g / 255
        b = b / 255

        const v = Math.max(r,g,b)
        const n = v - Math.min(r,g,b)
        const h = n === 0 ? 0 : n && v === r ? (g - b) / n : v === g ? 2 + (b - r) / n : 4 + (r - g) / n


        return [
            Math.ceil(60 * (h < 0 ? h + 6 : h)), // h
            Math.ceil(v && (n / v) * 100), // s
            Math.ceil(v * 100) // b
        ]
    }

    function hsbToHsl(arr){
        return `hsl(${arr[0]}%,${arr[1]}%,${arr[2]}%)`
    }

    return {
        getRgbFilterString,
        changeToRgba,
        changeToRgba255,
        changeToRgb,
        rgbToHsb,
        hsbToHsl
    }
}
